import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

const NoteWrapper = styled(Flex)`
    padding-top: 8px;
`;

interface ISpendRatesNoteProps {
    monthsWithoutRates: string[];
    currencyName: string;
}

/**
 * The endpoint models rates as their own rolling window, so a month can carry spend that no rate
 * covers. Such a month cannot be expressed outside USD and renders as a gap; this explains why.
 */
export const SpendRatesNote = ({ monthsWithoutRates, currencyName }: ISpendRatesNoteProps) => {
    if (monthsWithoutRates.length === 0) {
        return null;
    }

    return (
        <NoteWrapper data-automation="ppc-spend-chart-rates-note">
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[400]}
            >
                {translate("website.analysis.search.overview.graph.ppc.rates.unavailable.note", {
                    count: monthsWithoutRates.length,
                    currency: currencyName,
                })}
            </Text>
        </NoteWrapper>
    );
};
